import { IApp } from "@/types";

export namespace URLs {
  export const API_AUTH_LOGIN = "auth/login";
  export const API_AUTH_REGISTER = "auth/register";
  export const API_AUTH_PASSWORD_RESET = "auth/reset-password";
  export const API_AUTH_CONFIRM_PASSWORD_RESET = "auth/confirm-reset-password";
  export const API_AUTH_INFO = "auth/me";
  export const API_GOOGLE_SEARCH_CONSOLE_ANALYTICS = (
    userId: string,
    customerId: string,
    accountId: string
  ) => `account/${accountId}/google-search-console/analyze`;
  export const API_GOOGLE_ANALYTICS_ANALYTICS = (
    userId: string,
    customerId: string,
    accountId: string
  ) => `account/${accountId}/google-analytics/analyze`;
  export const API_BIRD_EYE_ANALYTICS = (userId: string, customerId: string, accountId: string) =>
    `account/${accountId}/bird-eye/analyze`;
  export const API_GOOGLE_SEARCH_CONSOLE_ANALYZE_ALL = (
    userId: string,
    customerId: string,
    accountId: string
  ) => `account/${accountId}/google-search-console/analyze-all`;
  export const API_GOOGLE_ANALYTICS_ANALYZE_ALL = (
    userId: string,
    customerId: string,
    accountId: string
  ) => `account/${accountId}/google-analytics/analyze-all`;
  export const API_BIRD_EYE_ANALYZE_ALL = (userId: string, customerId: string, accountId: string) =>
    `account/${accountId}/bird-eye/analyze-all`;
  export const API_AUTH_EMAIL_CONFIRM = "auth/confirm";
  export const API_AUTH_EMAIL_CONFIRM_RESEND_CODE = "auth/resend-code";
  export const API_ACCOUNT_LIST = (userId: string, customerId: string) =>
    `customer/${customerId}/account`;
  export const API_ACCOUNT_INFO = (userId: string, customerId: string, sourceId: string) =>
    `account/${sourceId}`;
  export const API_ACCOUNT_INFO_PATCH = (userId: string, customerId: string, sourceId: string) =>
    `account/${sourceId}`;
  export const API_ACCOUNT_STATUS_PUT = (userId: string, customerId: string, sourceId: string) =>
    `account/${sourceId}/status`;
  export const API_ACCOUNT_DATA_RELOAD = (userId: string, customerId: string, sourceId: string) =>
    `account/${sourceId}/reload`;
  export const API_ACCOUNT_GENERATE_GOOGLE_OAUTH_URL = (userId: string, customerId: string) =>
    `customer/${customerId}/account/connect/google`;
  export const API_ACCOUNT_CONNECT_ACCOUNT = (userId: string, customerId: string) =>
    `customer/${customerId}/account/connect`;
  export const API_GOOGLE_ANALYTICS__ACCOUNT_ACCOUNT_LIST = (
    userId: string,
    customerId: string,
    accountId: string
  ) => `account/${accountId}/google-analytics/account/accounts`;
  export const API_GOOGLE_ANALYTICS__ACCOUNT_ACCOUNT_PROPERTY_LIST = (
    userId: string,
    customerId: string,
    accountId: string
  ) => `account/${accountId}/google-analytics/account/accounts/properties`;
  export const API_GOOGLE_SEARCH_CONSOLE_SITE_LIST = (
    userId: string,
    customerId: string,
    sourceId: string
  ) => `account/${sourceId}/google-search-console/site-list`;
  export const API_CUSTOMER_CREATE = (userId: string) => `customer`;
  export const API_CUSTOMER_PATCH = (userId: string, id: string) => `customer/${id}`;
  export const API_CUSTOMER_DELETE = (userId: string, id: string) => `customer/${id}`;
  export const API_CUSTOMER_LIST = (userId: string) => `customer`;
  export const API_GLOBAL_CONTENT_PATCH = `global/content`;
  export const API_GLOBAL_CONTENT_GET = `global/content`;
  export const API_REPORT_GET = (requestId: string, reportId: string) =>
    `reports/${requestId}/${reportId}`;
  export const API_REPORT_CREATE = `reports`;
  export const API_REPORT_LIST = `reports`;
  export const API_REPORT_SUMMARIES = (requestId: string, reportId: string) =>
    `reports/${requestId}/${reportId}/summaries`;
  export const API_REPORT_CONFIRM = (requestId: string, reportId: string) =>
    `reports/${requestId}/${reportId}/confirm`;
  export const API_REPORT_SUMMARY_UPDATE = (requestId: string, reportId: string) =>
    `reports/${requestId}/${reportId}/summary`;
  export const API_REPORT_SUMMARY_GENERATE = `reports/summary/generate`;
  export const API_REPORT_PROMPT_GET = `reports/prompt`;
  export const API_REPORT_PROMPT_UPDATE = `reports/prompt`;
  export const API_PROFILE_GET = `profile`;
  export const API_PROFILE_UPDATE = `profile`;
  export const API_PROFILE_PROMPT_CREATE = `profile/prompts`;
  export const API_PROFILE_PROMPT_GET = (id: string) => `profile/prompts/${id}`;
  export const API_PROFILE_PROMPT_UPDATE = (id: string) => `profile/prompts/${id}`;
  export const API_PROFILE_PROMPT_DELETE = (id: string) => `profile/prompts/${id}`;

  export const PAGE_AUTH_LOGIN = "/auth/login";
  export const PAGE_AUTH_REGISTER = "/auth/register";
  export const PAGE_AUTH_CONFIRM_REGISTER = "/auth/confirm-register";
  export const PAGE_AUTH_PASSWORD_RESET = "/auth/password-reset";
  export const PAGE_AUTH_CONFIRM_PASSWORD_RESET = "/auth/confirm-password-reset";
  export const PAGE_AUTH_SSO_PROVIDER = "/auth/sso";
  export const PAGE_CUSTOMER_SOURCES = (customerId: string = ":customerId") =>
    `/customer/${customerId}/sources`;
  export const PAGE_CUSTOMER_LIST = "/customers";
  export const PAGE_CUSTOMER_EDIT = (customerId: string = ":customerId") =>
    `/customer/${customerId}/edit`;
  export const PAGE_HOME = "/";
  export const PAGE_PRIVACY = "/privacy";
  export const PAGE_TERMS = "/terms";
  export const PAGE_CUSTOMER_DASHBOARD = (id: string = ":customerId") => `/customer/${id}`;
  export const PAGE_MULTIPLE_CUSTOMER_DASHBOARD = `/customer/multiple`;
  export const PAGE_ACCOUNT_DASHBOARD = (id: string) => `/source/${id}`;
  export const PAGE_CALLBACK = "/callback";
  export const PAGE_SOURCE_EDIT = (
    customerId: string = ":customerId",
    sourceId: string = ":sourceId"
  ) => `/customer/${customerId}/source/${sourceId}/edit`;
  export const PAGE_SYNC_MONITOR = (
    customerId: string = ":customerId",
    sourceId: string = ":sourceId"
  ) => `/customer/${customerId}/source/${sourceId}/sync-monitor`;
  export const PAGE_SOURCE_CONNECT = (
    customerId: string = ":customerId",
    feed: IApp.IFeedTypes | ":feed" = ":feed"
  ) => `/customer/${customerId}/source/connect/${feed}`;
  export const PAGE_PROFILE = "/profile";

  export const PAGE_REPORT_LIST = `/reports`;
  export const PAGE_USAGE_DASHBOARD = `/usage`;

  export const ADMIN = {
    PAGE_PRIVACY_POLICY_EDIT: `/admin/privacy-policy/edit`,
    PAGE_TERMS_OF_SERVICE_EDIT: `/admin/terms-of-service/edit`,
    PAGE_REPORT_PROMPT_EDIT: `/admin/report/prompt/edit`
  };
}

export const ENVIRONMENTS = [
  IApp.IEnvironments.Local,
  IApp.IEnvironments.Dev,
  IApp.IEnvironments.Staging,
  IApp.IEnvironments.Prod
];

export const Env = {
  REDIRECT_URL: import.meta.env.VITE_GOOGLE_AUTH_REDIRECT_URI
};

export namespace Colors {
  export const Blue = "#4285F4";
  export const Teal = "#14b8a6";
  export const DarkBlue = "#0099ff";
  export const Green = "rgb(76, 175, 80)";
  export const Orange = "#FF9800";
  export const Red = "#F44336";
  export const Purple = "#673AB7";
  export const Grey = "#BDBDBD";
  export const BrightIndigo = "#6C5CE7";
}

export namespace Symbols {
  export const Compare = "⇌";
}

export namespace Constants {
  export const DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
  export const SUMMARY_GENERATION_PROMPT = ``;
  export const HUMAN_DATE_FORMAT = "MMMM D, YYYY [at] h:mm A";
  export const HUMAN_DATE_FORMAT_SHORT = "MMM D, YYYY";
  export const DATA_FETCH_CHUNK_SIZE = 3;
}
